export const airportsTSA = [
  { code: 'BOS', region: 'Northeast', top: '25%', left: '95%' },
  { code: 'EWR', region: 'Northeast', top: '31%', left: '93%' },
  { code: 'JFK', region: 'Northeast' },
  { code: 'LGA', region: 'Northeast', top: '31%', left: '91.7%' },
  { code: 'PHL', region: 'Northeast', top: '36%', left: '90.5%' },
  { code: 'ABE', region: 'Northeast' },
  // { code: 'ACY', region: 'Northeast' },
  { code: 'BUF', region: 'Northeast' },
  { code: 'BDL', region: 'Northeast' },
  { code: 'HPN', region: 'Northeast' },
  { code: 'PWM', region: 'Northeast' },
  { code: 'PVD', region: 'Northeast' },
  { code: 'ALB', region: 'Northeast' },
  { code: 'AVP', region: 'Northeast' },
  // { code: 'BED', region: 'Northeast' },
  { code: 'BGR', region: 'Northeast' },
  // { code: 'CEF', region: 'Northeast' },
  { code: 'ISP', region: 'Northeast' },
  { code: 'MHT', region: 'Northeast' },
  // { code: 'ORH', region: 'Northeast' },
  { code: 'SYR', region: 'Northeast' },
  { code: 'ROC', region: 'Northeast' },
  // { code: 'RME', region: 'Northeast' },
  // { code: 'SLK', region: 'Northeast' },
  { code: 'SWF', region: 'Northeast' },
  // { code: 'IAG', region: 'Northeast' },
  // { code: 'OGS', region: 'Northeast' },
  // { code: 'RUT', region: 'Northeast' },
  // { code: 'PVC', region: 'Northeast' },
  // { code: 'MVY', region: 'Northeast' },
  // { code: 'ACK', region: 'Northeast' },
  // { code: 'UCA', region: 'Northeast' },
  // { code: 'GON', region: 'Northeast' },
  // { code: 'HVN', region: 'Northeast' },
  // { code: 'AUG', region: 'Northeast' },
  // { code: 'ART', region: 'Northeast' },
  // { code: 'BGM', region: 'Northeast' },
  // { code: 'BFD', region: 'Northeast' },
  // { code: 'FKL', region: 'Northeast' },
  // { code: 'HYA', region: 'Northeast' },
  { code: 'ITH', region: 'Northeast' },
  // { code: 'JHW', region: 'Northeast' },
  // { code: 'JST', region: 'Northeast' },
  // { code: 'LBE', region: 'Northeast' },
  // { code: 'LNS', region: 'Northeast' },
  // { code: 'MSS', region: 'Northeast' },
  // { code: 'PBG', region: 'Northeast' },
  // { code: 'PQI', region: 'Northeast' },
  // { code: 'PSM', region: 'Northeast' },
  // { code: 'RDG', region: 'Northeast' },
  // { code: 'RKD', region: 'Northeast' },
  // { code: 'TTN', region: 'Northeast' },
  // { code: 'UNV', region: 'Northeast' },
  { code: 'BTV', region: 'Northeast' },
  // { code: 'BHB', region: 'Northeast' },
  // { code: 'LEB', region: 'Northeast' },
  // { code: 'SHD', region: 'Northeast' },
  { code: 'DCA', region: 'Northeast' },
  { code: 'IAD', region: 'Northeast' },

  { code: 'ATL', region: 'Southeast', top: '63%', left: '79%' },
  { code: 'BNA', region: 'Southeast', top: '56%', left: '74%' },
  { code: 'BWI', region: 'Southeast', top: '38.7%', left: '88%' },
  { code: 'CLT', region: 'Southeast', top: '54.5%', left: '84%' },
  { code: 'MCO', region: 'Southeast', top: '77.5%', left: '85.4%' },
  { code: 'MIA', region: 'Southeast', top: '88%', left: '88%' },
  { code: 'MSY', region: 'Southeast', top: '79%', left: '70%' },
  { code: 'AVL', region: 'Southeast' },
  { code: 'CHA', region: 'Southeast' },
  { code: 'GSO', region: 'Southeast' },
  { code: 'CVG', region: 'Southeast' },
  { code: 'JAN', region: 'Southeast' },
  { code: 'JAX', region: 'Southeast' },
  { code: 'LEX', region: 'Southeast' },
  { code: 'SDF', region: 'Southeast' },
  { code: 'RDU', region: 'Southeast' },
  { code: 'RIC', region: 'Southeast' },
  { code: 'SRQ', region: 'Southeast' },
  { code: 'TPA', region: 'Southeast' },
  { code: 'TYS', region: 'Southeast' },
  { code: 'VPS', region: 'Southeast' },
  { code: 'ORF', region: 'Southeast' },
  { code: 'PBI', region: 'Southeast' },
  { code: 'FLL', region: 'Southeast' },
  { code: 'RSW', region: 'Southeast' },
  { code: 'MYR', region: 'Southeast' },
  { code: 'SAV', region: 'Southeast' },
  { code: 'CHS', region: 'Southeast' },
  { code: 'FAY', region: 'Southeast' },
  { code: 'EWN', region: 'Southeast' },
  { code: 'ILM', region: 'Southeast' },
  { code: 'CAE', region: 'Southeast' },
  { code: 'GSP', region: 'Southeast' },
  { code: 'TLH', region: 'Southeast' },
  { code: 'GNV', region: 'Southeast' },
  { code: 'EYW', region: 'Southeast' },
  // { code: 'PIE', region: 'Southeast' },
  // { code: 'OCF', region: 'Southeast' },
  // { code: 'LAL', region: 'Southeast' },
  // { code: 'SFB', region: 'Southeast' },
  // { code: 'SGJ', region: 'Southeast' },
  { code: 'ABY', region: 'Southeast' },
  { code: 'AGS', region: 'Southeast' },
  // { code: 'AHN', region: 'Southeast' },
  { code: 'BHM', region: 'Southeast' },
  // { code: 'BKW', region: 'Southeast' },
  { code: 'BQK', region: 'Southeast' },
  { code: 'CSG', region: 'Southeast' },
  { code: 'DAB', region: 'Southeast' },
  { code: 'DHN', region: 'Southeast' },
  { code: 'FLO', region: 'Southeast' },
  { code: 'GPT', region: 'Southeast' },
  // { code: 'HXD', region: 'Southeast' },
  // { code: 'MCN', region: 'Southeast' },
  { code: 'MLB', region: 'Southeast' },
  { code: 'MGM', region: 'Southeast' },
  { code: 'MOB', region: 'Southeast' },
  // { code: 'ECP', region: 'Southeast' },
  { code: 'PNS', region: 'Southeast' },
  { code: 'VLD', region: 'Southeast' },
  // { code: 'TCL', region: 'Southeast' },
  // { code: 'MQY', region: 'Southeast' },
  // { code: 'SME', region: 'Southeast' },
  // { code: 'TUP', region: 'Southeast' },

  { code: 'DTW', region: 'Midwest', top: '35%', left: '77%' },
  { code: 'MSP', region: 'Midwest', top: '28%', left: '62%' },
  { code: 'ORD', region: 'Midwest', top: '37%', left: '70.5%' },
  { code: 'CLE', region: 'Midwest' },
  { code: 'DSM', region: 'Midwest' },
  { code: 'GRR', region: 'Midwest' },
  { code: 'GRB', region: 'Midwest' },
  { code: 'IND', region: 'Midwest' },
  { code: 'MCI', region: 'Midwest' },
  { code: 'MDT', region: 'Midwest' },
  { code: 'MKE', region: 'Midwest' },
  { code: 'ICT', region: 'Midwest' },
  { code: 'CMH', region: 'Midwest' },
  { code: 'DAY', region: 'Midwest' },
  { code: 'SBN', region: 'Midwest' },
  { code: 'CAK', region: 'Midwest' },
  { code: 'TOL', region: 'Midwest' },
  // { code: 'YNG', region: 'Midwest' },
  // { code: 'GYY', region: 'Midwest' },
  { code: 'AZO', region: 'Midwest' },
  { code: 'LAN', region: 'Midwest' },
  { code: 'FNT', region: 'Midwest' },
  { code: 'MBS', region: 'Midwest' },
  // { code: 'CIU', region: 'Midwest' },
  // { code: 'IMT', region: 'Midwest' },
  // { code: 'SAW', region: 'Midwest' },
  { code: 'RST', region: 'Midwest' },
  { code: 'DLH', region: 'Midwest' },
  // { code: 'HIB', region: 'Midwest' },
  // { code: 'INL', region: 'Midwest' },
  // { code: 'TVF', region: 'Midwest' },
  // { code: 'BJI', region: 'Midwest' },
  // { code: 'BRD', region: 'Midwest' },
  { code: 'CWA', region: 'Midwest' },
  // { code: 'RHI', region: 'Midwest' },
  // { code: 'MKG', region: 'Midwest' },
  { code: 'PLN', region: 'Midwest' },
  // { code: 'APN', region: 'Midwest' },
  { code: 'ATW', region: 'Midwest' },
  { code: 'BMI', region: 'Midwest' },
  // { code: 'BMG', region: 'Midwest' },
  // { code: 'BRL', region: 'Midwest' },
  // { code: 'CGI', region: 'Midwest' },
  { code: 'CID', region: 'Midwest' },
  { code: 'CMI', region: 'Midwest' },
  { code: 'CMX', region: 'Midwest' },
  // { code: 'DEC', region: 'Midwest' },
  { code: 'DBQ', region: 'Midwest' },
  // { code: 'DVL', region: 'Midwest' },
  // { code: 'EAU', region: 'Midwest' },
  { code: 'EVV', region: 'Midwest' },
  // { code: 'FOD', region: 'Midwest' },
  { code: 'FWA', region: 'Midwest' },
  { code: 'LSE', region: 'Midwest' },
  // { code: 'MBL', region: 'Midwest' },
  // { code: 'MCW', region: 'Midwest' },
  { code: 'MSN', region: 'Midwest' },
  // { code: 'MWA', region: 'Midwest' },
  { code: 'PIA', region: 'Midwest' },
  // { code: 'RFD', region: 'Midwest' },
  // { code: 'SUX', region: 'Midwest' },
  { code: 'FSD', region: 'Midwest' },
  // { code: 'STC', region: 'Midwest' },
  { code: 'TVC', region: 'Midwest' },
  // { code: 'YIP', region: 'Midwest' },

  { code: 'AUS', region: 'Southwest', top: '76%', left: '55%' },
  { code: 'DFW', region: 'Southwest', top: '69%', left: '58%' },
  { code: 'IAH', region: 'Southwest', top: '80%', left: '60%' },
  { code: 'PHX', region: 'Southwest', top: '68%', left: '32%' },
  { code: 'DAL', region: 'Southwest' },
  { code: 'HOU', region: 'Southwest' },
  { code: 'ELP', region: 'Southwest' },
  { code: 'LIT', region: 'Southwest' },
  { code: 'TUS', region: 'Southwest' },
  { code: 'LAS', region: 'Southwest', top: '56%', left: '27.5%' },
  { code: 'STL', region: 'Southwest' },
  { code: 'SAT', region: 'Southwest' },
  { code: 'TUL', region: 'Southwest' },
  { code: 'OKC', region: 'Southwest' },
  { code: 'SHV', region: 'Southwest' },
  { code: 'TYR', region: 'Southwest' },
  { code: 'ACT', region: 'Southwest' },
  { code: 'CRP', region: 'Southwest' },
  { code: 'LRD', region: 'Southwest' },
  { code: 'MFE', region: 'Southwest' },
  { code: 'BRO', region: 'Southwest' },
  // { code: 'BPT', region: 'Southwest' },
  // { code: 'DRT', region: 'Southwest' },
  { code: 'SJT', region: 'Southwest' },
  { code: 'GRK', region: 'Southwest' },
  { code: 'GGG', region: 'Southwest' },
  { code: 'MAF', region: 'Southwest' },
  { code: 'ABI', region: 'Southwest' },
  { code: 'AMA', region: 'Southwest' },
  { code: 'LBB', region: 'Southwest' },
  { code: 'SPS', region: 'Southwest' },
  { code: 'TXK', region: 'Southwest' },
  { code: 'AEX', region: 'Southwest' },
  // { code: 'ESF', region: 'Southwest' },
  { code: 'ABQ', region: 'Southwest' },
  // { code: 'AIA', region: 'Southwest' },
  // { code: 'ALS', region: 'Southwest' },
  { code: 'CLL', region: 'Southwest' },
  { code: 'COS', region: 'Southwest' },
  // { code: 'COU', region: 'Southwest' },
  // { code: 'DDC', region: 'Southwest' },
  { code: 'DRO', region: 'Southwest' },
  // { code: 'ELD', region: 'Southwest' },
  // { code: 'FMN', region: 'Southwest' },
  // { code: 'FSM', region: 'Southwest' },
  // { code: 'GUP', region: 'Southwest' },
  // { code: 'HOB', region: 'Southwest' },
  { code: 'HRL', region: 'Southwest' },
  { code: 'LAW', region: 'Southwest' },
  { code: 'LCH', region: 'Southwest' },
  { code: 'LFT', region: 'Southwest' },
  { code: 'MLU', region: 'Southwest' },
  { code: 'ROW', region: 'Southwest' },
  // { code: 'SAF', region: 'Southwest' },
  { code: 'SGF', region: 'Southwest' },
  // { code: 'SLN', region: 'Southwest' },
  // { code: 'SWO', region: 'Southwest' },
  // { code: 'TEX', region: 'Southwest' },
  // { code: 'VCT', region: 'Southwest' },
  // { code: 'PAH', region: 'Southwest' },

  { code: 'DEN', region: 'West', top: '46%', left: '45%' },
  { code: 'LAX', region: 'West', top: '59%', left: '21%' },
  { code: 'PSP', region: 'West', top: '61%', left: '23%' },
  { code: 'SAN', region: 'West', top: '65.5%', left: '23.5%' },
  { code: 'SEA', region: 'West', top: '12%', left: '22%' },
  { code: 'SFO', region: 'West', top: '42%', left: '16%' },
  { code: 'SLC', region: 'West', top: '42%', left: '34%' },
  { code: 'ANC', region: 'West' },
  // { code: 'BLI', region: 'West' },
  { code: 'OAK', region: 'West' },
  { code: 'OMA', region: 'West' },
  { code: 'ONT', region: 'West' },
  { code: 'PDX', region: 'West' },
  { code: 'RDM', region: 'West' },
  { code: 'RNO', region: 'West' },
  { code: 'SMF', region: 'West' },
  { code: 'SJC', region: 'West' },
  { code: 'SNA', region: 'West' },
  // { code: 'STS', region: 'West' },
  { code: 'BUR', region: 'West' },
  { code: 'LGB', region: 'West' },
  { code: 'SBA', region: 'West' },
  { code: 'SBP', region: 'West' },
  { code: 'SMX', region: 'West' },
  { code: 'RDD', region: 'West' },
  { code: 'CEC', region: 'West' },
  { code: 'ACV', region: 'West' },
  { code: 'FAT', region: 'West' },
  { code: 'MOD', region: 'West' },
  { code: 'MRY', region: 'West' },
  // { code: 'IPL', region: 'West' },
  // { code: 'IWA', region: 'West' },
  // { code: 'PRC', region: 'West' },
  { code: 'FLG', region: 'West' },
  // { code: 'GCN', region: 'West' },
  // { code: 'SOW', region: 'West' },
  // { code: 'NYL', region: 'West' },
  // { code: 'VIS', region: 'West' },
  // { code: 'OXR', region: 'West' },
  // { code: 'PMD', region: 'West' },
  { code: 'ASE', region: 'West' },
  // { code: 'BFL', region: 'West' },
  { code: 'BOI', region: 'West' },
  // { code: 'CIC', region: 'West' },
  { code: 'CPR', region: 'West' },
  // { code: 'CDC', region: 'West' },
  // { code: 'CEZ', region: 'West' },
  { code: 'COD', region: 'West' },
  // { code: 'CYS', region: 'West' },
  // { code: 'EAT', region: 'West' },
  { code: 'EGE', region: 'West' },
  // { code: 'EKO', region: 'West' },
  // { code: 'ELY', region: 'West' },
  { code: 'EUG', region: 'West' },
  { code: 'FCA', region: 'West' },
  { code: 'GJT', region: 'West' },
  // { code: 'GUC', region: 'West' },
  { code: 'HDN', region: 'West' },
  // { code: 'IYK', region: 'West' },
  { code: 'JAC', region: 'West' },
  { code: 'LMT', region: 'West' },
  // { code: 'MMH', region: 'West' },
  // { code: 'MTJ', region: 'West' },
  // { code: 'OTH', region: 'West' },
  // { code: 'PDT', region: 'West' },
  // { code: 'PGA', region: 'West' },
  // { code: 'PUB', region: 'West' },
  // { code: 'PUW', region: 'West' },
  { code: 'RAP', region: 'West' },
  { code: 'RKS', region: 'West' },
  // { code: 'SCK', region: 'West' },
  // { code: 'SGU', region: 'West' },
  // { code: 'SHR', region: 'West' },
  // { code: 'SUN', region: 'West' },
  { code: 'TWF', region: 'West' },
  // { code: 'WYS', region: 'West' },
  // { code: 'YKM', region: 'West' },

  { code: 'FAI', region: 'Alaska' },
  { code: 'JNU', region: 'Alaska' },
  { code: 'KTN', region: 'Alaska' },
  // { code: 'SIT', region: 'Alaska' },
  { code: 'BET', region: 'Alaska' },
  { code: 'OME', region: 'Alaska' },
  // { code: 'ADQ', region: 'Alaska' },
  // { code: 'OTZ', region: 'Alaska' },
  // { code: 'WRG', region: 'Alaska' },
  { code: 'YAK', region: 'Alaska' },
  { code: 'BRW', region: 'Alaska' },
  // { code: 'CDV', region: 'Alaska' },
  // { code: 'DLG', region: 'Alaska' },
  // { code: 'DUT', region: 'Alaska' },
  // { code: 'ENA', region: 'Alaska' },
  // { code: 'GST', region: 'Alaska' },
  // { code: 'HOM', region: 'Alaska' },
  // { code: 'AKN', region: 'Alaska' },
  // { code: 'VDZ', region: 'Alaska' },
  // { code: 'SCC', region: 'Alaska' },
  // { code: 'ADK', region: 'Alaska' },
  // { code: 'PSG', region: 'Alaska' },

  // { code: 'HNL', region: 'Hawaii' },
  { code: 'OGG', region: 'Hawaii' },
  { code: 'KOA', region: 'Hawaii' },
  { code: 'LIH', region: 'Hawaii' },
  { code: 'ITO', region: 'Hawaii' },
  // { code: 'MKK', region: 'Hawaii' },
  // { code: 'LNY', region: 'Hawaii' },
  // { code: 'JHM', region: 'Hawaii' },

  { code: 'SJU', region: 'Territories' },
  { code: 'BQN', region: 'Territories' },
  { code: 'PSE', region: 'Territories' },
  // { code: 'VQS', region: 'Territories' },
  { code: 'STT', region: 'Territories' },
  { code: 'STX', region: 'Territories' },
  // { code: 'PPG', region: 'Territories' },
  { code: 'PSC', region: 'Territories' },
];


const tsaCodes = new Set(airportsTSA.map(({ code }) => code.toUpperCase()));

export function isTSA(code: string): boolean {
  return tsaCodes.has(code.toUpperCase());
}
